import { useCallback } from 'react';

import CustomForm from '../../common/CustomForm/CustomForm';
import CustomInput from '../../common/CustomInput/CustomInput';
import { isValidEmail } from '../../core/helpers';
import useFetch from '../../core/hooks/useFetch';
import { useFormInput } from '../../core/hooks/useFormInput';

const BASE_URL = process.env.REACT_APP_SC_API_BASE;

function ForgotPassword() {
  const email = useFormInput('', (value) => isValidEmail(value));
  const { result, doFetch, loading, error } = useFetch(`${BASE_URL}/user/send-reset-password-link`);

  const handleSubmit = useCallback(() => {
    doFetch({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email.value,
      }),
    });
  }, [email]);

  return (
    <section>
      <div className="wrap">
        <div className="form-container">
          <h1 className="h3">Forgot your password?</h1>
          <h2 className="h4" style={{ marginBottom: '30px' }}>
            Enter your e-mail to send a password reset link.
          </h2>
          <CustomForm inputs={[email]} onSubmit={handleSubmit}>
            <>
              <CustomInput
                id="email"
                type="text"
                name="email"
                placeholder="Enter your email address"
                label="Email address"
                input={email}
                emptyMessage="Please fill in your email"
                invalidMessage="Plese fill in a valid email address"
              />
              <button className="btn btn--blue" type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send'}
              </button>
            </>
          </CustomForm>
        </div>
      </div>
    </section>
  );
}

export default ForgotPassword;
